module.exports = __webpack_public_path__ + "static/media/20x24no1.3567a1af.jpg";